<table mat-table [dataSource]="data" class="mat-elevation-z8">
	<ng-container matColumnDef="vehicle">
		<th mat-header-cell *matHeaderCellDef>Pojazd</th>
		<td mat-cell *matCellDef="let element">
			{{ element.vehicleName }}
			<i class="fas fa-sign-in-alt fa-flip-horizontal" *ngIf="element.action === 'BA'"></i>
			<i class="fas fa-sign-out-alt" *ngIf="element.action === 'DO'"></i>
			<i class="fas fa-arrow-right" *ngIf="element.action === 'CR'"></i>
			<i class="fas fa-suitcase-rolling" *ngIf="element.action === 'TG'"></i>
		</td>
	</ng-container>

	<ng-container matColumnDef="city">
		<th mat-header-cell *matHeaderCellDef>Miasto</th>
		<td mat-cell *matCellDef="let element">
			{{ element.cityName }}
			<div class="cityAddress" *ngIf="element.cityType === 'DO'">
				{{ element.cityAddress }}
			</div>
		</td>
	</ng-container>

	<ng-container matColumnDef="fee">
		<th mat-header-cell *matHeaderCellDef>Dopłata</th>
		<td mat-cell *matCellDef="let element">
			<input
				type="number"
				class="form-control"
				min="0"
				name="fee"
				[(ngModel)]="element.fee"
				*ngIf="['BA', 'BR'].includes(element.cityType)"
			/>
		</td>
	</ng-container>

	<ng-container matColumnDef="stopTime">
		<th mat-header-cell *matHeaderCellDef>Przerwa</th>
		<td mat-cell *matCellDef="let element">
			<div class="input-group" *ngIf="['BA', 'BR'].includes(element.cityType)">
				<input
					type="number"
					class="form-control"
					min="0"
					name="stopTime"
					[(ngModel)]="element.stopTime"
					(change)="hourChanged(element)"
					[disabled]="!element.stopTimeEditable"
				/>
				<span class="input-group-text">min.</span>
			</div>
		</td>
	</ng-container>

	<ng-container matColumnDef="datetime">
		<th mat-header-cell *matHeaderCellDef>Godzina odjazdu</th>
		<td mat-cell *matCellDef="let element">
			<div class="input-group mb-3">
				<input
					type="date"
					class="form-control smallBox"
					[(ngModel)]="element.date"
					name="date"
					(change)="hourChanged(element)"
					[disabled]="!element.timeEditable"
				/>
				<input
					type="time"
					step="300"
					class="form-control smallerBox"
					[(ngModel)]="element.time"
					name="time"
					(change)="hourChanged(element)"
					[disabled]="!element.timeEditable"
				/>
			</div>
		</td>
	</ng-container>

	<ng-container matColumnDef="traffic">
		<th mat-header-cell *matHeaderCellDef>Natężenie</th>
		<td mat-cell *matCellDef="let element">
			<select
				class="form-select"
				[(ngModel)]="element.traffic"
				name="traffic_{{ element.id }}"
				(change)="hourChanged(element)"
				[disabled]="!element.stopTimeEditable"
				*ngIf="['BA', 'BR'].includes(element.cityType)"
			>
				<option value="0">Niskie</option>
				<option value="1">Średnie</option>
				<option value="2">Duże</option>
			</select>
		</td>
	</ng-container>

	<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
	<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
